import { render } from "./Inventory_TransferExport_Dialog.vue?vue&type=template&id=66b08405&scoped=true&ts=true"
import script from "./Inventory_TransferExport_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_TransferExport_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_TransferExport_Dialog.vue?vue&type=style&index=0&id=66b08405&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b08405"]])

export default __exports__